"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourierTransport = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _ws = require("../ws");

var _base = require("../base");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CourierTransport = /*#__PURE__*/function (_Transport) {
  (0, _inherits2["default"])(CourierTransport, _Transport);

  var _super = _createSuper(CourierTransport);

  function CourierTransport(options) {
    var _options$wsOptions;

    var _this;

    (0, _classCallCheck2["default"])(this, CourierTransport);
    _this = _super.call(this);
    var clientKeyOptions = options;
    var jwtOptions = options;

    if (!clientKeyOptions.clientKey && !jwtOptions.authorization) {
      throw new Error("Missing Authorization");
    }

    _this.authorization = jwtOptions.authorization;
    _this.clientSourceId = options.clientSourceId;
    _this.clientKey = clientKeyOptions.clientKey;
    _this.userSignature = clientKeyOptions.userSignature;
    _this.ws = new _ws.CourierWS({
      tenantId: options.tenantId,
      authorization: jwtOptions.authorization,
      clientSourceId: options.clientSourceId,
      clientKey: clientKeyOptions.clientKey,
      options: options.wsOptions,
      userSignature: clientKeyOptions.userSignature
    });

    if ((_options$wsOptions = options.wsOptions) !== null && _options$wsOptions !== void 0 && _options$wsOptions.onReconnect) {
      var _options$wsOptions2;

      _this.ws.onReconnection({
        id: "propReconnect",
        callback: (_options$wsOptions2 = options.wsOptions) === null || _options$wsOptions2 === void 0 ? void 0 : _options$wsOptions2.onReconnect
      });
    }

    return _this;
  }

  (0, _createClass2["default"])(CourierTransport, [{
    key: "closeConnection",
    value: function closeConnection() {
      this.ws.close();
    }
  }, {
    key: "connect",
    value: function connect() {
      this.ws.connect();
    }
  }, {
    key: "isConnected",
    value: function isConnected() {
      return this.ws.connected;
    }
  }, {
    key: "keepAlive",
    value: function keepAlive() {
      this.ws.send({
        action: "keepAlive"
      });
    }
  }, {
    key: "send",
    value: function send(message) {
      this.ws.send(_objectSpread(_objectSpread({}, message), {}, {
        data: _objectSpread(_objectSpread({}, message.data), {}, {
          clientKey: this.clientKey
        })
      }));
    }
  }, {
    key: "subscribe",
    value: function subscribe(channel, event) {
      var _this2 = this;

      this.ws.subscribe(channel, event !== null && event !== void 0 ? event : "*", function (_ref) {
        var _courierEvent$type;

        var courierEvent = _ref.data;

        if (_this2.interceptor) {
          courierEvent = _this2.interceptor(courierEvent);
        }

        if (!courierEvent) {
          return;
        }

        _this2.emit({
          type: (_courierEvent$type = courierEvent.type) !== null && _courierEvent$type !== void 0 ? _courierEvent$type : "message",
          data: courierEvent
        });
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(channel, event) {
      this.ws.unsubscribe(channel, event !== null && event !== void 0 ? event : "*");
    }
  }, {
    key: "onReconnection",
    value: function onReconnection(handler) {
      this.ws.onReconnection(handler);
    }
  }, {
    key: "renewSession",
    value: function renewSession(token) {
      this.ws.renewSession(token);
    }
  }]);
  return CourierTransport;
}(_base.Transport);

exports.CourierTransport = CourierTransport;